import Marquee from "react-fast-marquee";
import { useLang } from "@/lib/i18n";

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <div data-testid="editorial-marquee" className="border-y border-white/10 py-6 bg-[#060A14] overflow-hidden">
      <Marquee speed={32} gradient={false} pauseOnHover>
        {t.marquee.map((item) => (
          <span key={item} className="flex items-center">
            <span className="text-sm md:text-base uppercase tracking-[0.3em] text-[#94A3B8] font-display font-medium px-8">
              {item}
            </span>
            <span className="w-2 h-2 bg-gold rotate-45 inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
